import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    specialisationSubtitle: {
        fontSize: 14,
        margin: '8px 0'
    },
    subTitle: {
        fontSize: '16px',
        marginRight: '10px',
        marginBottom: '32px'
    },
    toggleSwitch: {
        marginBottom: '30px'
    }
}))
